'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasdr';
var iconName = 'umbrella-beach';
var width = 576;
var height = 512;
var aliases = [127958];
var unicode = 'f5ca';
var svgPathData = ['M163.1 120l68.8 25c14.2-32.9 33.4-63.4 57-90.4c-48 6.4-92.7 29.5-125.8 65.4zm114 41.5L413.3 211c9.4-32.5 13.2-66.4 11.2-100.2c-1.1-18.2-12-34.2-28.2-41.9c-3-1.2-5.9-2.4-9-3.5c-1-.4-1.9-.7-2.9-1c-18.2-5.9-38.3-.9-51.5 13.1c-23.3 24.6-42.2 53.1-55.9 84zm181.5 66.1L524 251.3c-2.2-47-20.3-91.9-51-127.2c.4 35-4.5 69.8-14.5 103.3z', 'M572.1 268.8c-.5 16.2-2.6 32.5-6.3 48.8l-45.5-16.6-77.6-28.3s0 0 0 0L214.9 189.9s0 0 0 0L134 160.4 88.4 143.9C96 129 104.9 115.2 115 102.4c66.5-84.6 182.2-121 288.8-82.2s171.8 141 168.4 248.6zM473 124.2c.4 35-4.5 69.8-14.5 103.3L524 251.3c-2.2-47-20.3-91.9-51-127.2zM396.3 68.9c-3-1.2-5.9-2.4-9-3.5c-1-.4-1.9-.7-2.9-1c-18.2-5.9-38.3-.9-51.5 13.1c-23.3 24.6-42.2 53.1-55.9 84L413.3 211c9.4-32.5 13.2-66.4 11.2-100.2c-1.1-18.2-12-34.2-28.2-41.9zM288.8 54.6c-48 6.4-92.7 29.5-125.8 65.4l68.8 25c14.2-32.9 33.4-63.4 57-90.4zM552 464l24 0 0 48-24 0L24 512 0 512l0-48 24 0 192.7 0 76.9-211.4L338.7 269l-71 195L552 464z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUmbrellaBeach = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;